<div class="modal-header">
  <h5 class="modal-title">
    <i class="bi bi-key me-2"></i>
    {{ 'EmployeeTenantAccess.grantAccess' | translate }}
  </h5>
  <button type="button" class="btn-close" [disabled]="saving" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <div *ngIf="loading" class="text-center py-4">
    <div class="spinner-border text-primary"></div>
  </div>

  <form [formGroup]="accessForm" *ngIf="!loading">
    <!-- User Selection (using UserManagement DTO from User/GetSysUserList) -->
    <div class="mb-3">
      <label class="form-label required">
        {{ 'EmployeeTenantAccess.selectEmployee' | translate }}
      </label>
      <select class="form-select" 
              formControlName="userEmail"
              [class.is-invalid]="accessForm.get('userEmail')?.invalid && accessForm.get('userEmail')?.touched">
        <option [ngValue]="null">{{ 'General.selectOption' | translate }}</option>
        <option *ngFor="let user of employees" [value]="user.userEmail || user.userName">
          {{ user.userFullname }} ({{ user.userEmail || user.userName }})
        </option>
      </select>
      <div class="invalid-feedback" *ngIf="accessForm.get('userEmail')?.invalid && accessForm.get('userEmail')?.touched">
        {{ 'General.required' | translate }}
      </div>
    </div>

    <!-- Tenant Group Selection -->
    <div class="mb-3">
      <label class="form-label required">
        {{ 'EmployeeTenantAccess.selectTenantGroup' | translate }}
      </label>
      <select class="form-select" 
              formControlName="groupID"
              [class.is-invalid]="accessForm.get('groupID')?.invalid && accessForm.get('groupID')?.touched">
        <option [ngValue]="null">{{ 'General.selectOption' | translate }}</option>
        <option *ngFor="let group of tenantGroups" [ngValue]="group.groupID">
          {{ group.groupName }}
        </option>
      </select>
      <div class="invalid-feedback" *ngIf="accessForm.get('groupID')?.invalid && accessForm.get('groupID')?.touched">
        {{ 'General.required' | translate }}
      </div>
      <div class="form-text">
        {{ 'EmployeeTenantAccess.grantAccessHelp' | translate }}
      </div>
    </div>

    <!-- Info Alert -->
    <div class="alert alert-info mb-0">
      <i class="bi bi-info-circle me-2"></i>
      <small>{{ 'EmployeeTenantAccess.grantAccessInfo' | translate }}</small>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" 
          class="btn btn-secondary" 
          [disabled]="saving"
          (click)="cancel()">
    {{ 'General.cancel' | translate }}
  </button>
  <button type="button" 
          class="btn btn-primary" 
          [disabled]="saving || accessForm.invalid || loading"
          (click)="save()">
    <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
    <i class="bi bi-key me-1" *ngIf="!saving"></i>
    {{ 'EmployeeTenantAccess.grantAccess' | translate }}
  </button>
</div>
